import { cn } from "../../lib/utils";

export function Iphone({ className, children }) {
  return (
    <div
      className={cn(
        "relative mx-auto aspect-[9/19.5] w-full max-w-[320px] rounded-[2.7rem] border border-slate-500/40 bg-slate-800 p-2 shadow-[0_30px_80px_rgba(2,6,23,.55)]",
        className
      )}
    >
      <div className="pointer-events-none absolute left-[-2px] top-24 h-14 w-[3px] rounded-full bg-slate-500/70" aria-hidden />
      <div className="pointer-events-none absolute right-[-2px] top-20 h-24 w-[3px] rounded-full bg-slate-500/70" aria-hidden />
      <div className="pointer-events-none absolute right-[-2px] top-48 h-16 w-[3px] rounded-full bg-slate-500/70" aria-hidden />

      <div className="relative h-full w-full overflow-hidden rounded-[2.2rem] border border-slate-700 bg-black">
        <div className="pointer-events-none absolute left-1/2 top-2 z-20 h-6 w-28 -translate-x-1/2 rounded-full border border-slate-700 bg-black" aria-hidden />
        <div className="h-full w-full">{children}</div>
      </div>
    </div>
  );
}
